import React from 'react';
import { useSelector } from 'react-redux';
import { checkConnectivity } from 'modules/home/selectors';
import { Navigate } from 'react-router-dom';
import ROUTES from 'modules/common/constants/route';
import { getMasterAdmin } from 'modules/admin/selectors';

const MasterAdminRoute = ({ component: Component }) => {
  const isConnected = useSelector(checkConnectivity);
  const master = useSelector(getMasterAdmin);
  return isConnected?.connected && isConnected.account === master ? (
    <Component />
  ) : (
    <Navigate to={ROUTES.ADMIN} />
  );
};

export default MasterAdminRoute;
